import { useState } from "react";
import { toast } from "sonner";
import { ChefHat, Plus, Trash2, UtensilsCrossed } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Panel, inputCls } from "@/components/kit";
import { api, errMsg, fmtMoney, openPdf } from "@/lib/api";

const SUGGEST = ["Materie prime cucina", "Bevande e vini", "Personale di sala", "Personale di cucina", "Allestimenti e fiori", "Noleggi", "Musica / DJ", "Pulizie"];

export function ServicePanel({ c, reload }) {
  const [costs, setCosts] = useState(c.costs || []);
  const [notes, setNotes] = useState(c.service_notes || "");
  const price = Number(c.data?.prezzo_riferimento || 0);
  const tot = costs.reduce((t, x) => t + Number(x.importo || 0), 0);
  const margin = price - tot;
  const save = async () => {
    try {
      await api.put(`/contracts/${c.id}/costs`, { costs: costs.map((x) => ({ ...x, importo: Number(x.importo || 0) })), service_notes: notes });
      toast.success("Salvato");
      reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="space-y-6">
      <Panel title="Scheda di servizio" testId="service-sheets">
        <p className="text-sm text-[#47606B]">Si crea da sola dal contratto: orari, coperti (dalla lista invitati o dal minimo garantito), menù, allergie, menù speciali, tavoli, Allegato B ed extra confermati.</p>
        <div className="flex flex-wrap gap-2">
          <Button variant="outline" className="rounded-full" onClick={() => openPdf(`/contracts/${c.id}/service-sheet?kind=cucina`)} data-testid="sheet-kitchen"><ChefHat size={15} className="mr-2" /> Scheda cucina</Button>
          <Button variant="outline" className="rounded-full" onClick={() => openPdf(`/contracts/${c.id}/service-sheet?kind=sala`)} data-testid="sheet-hall"><UtensilsCrossed size={15} className="mr-2" /> Scheda sala</Button>
        </div>
        <textarea rows={4} className={inputCls} value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Note operative per lo staff (es. arrivo sposi 19:30, taglio torta 23:00, fornitore fiori ore 15)…" data-testid="service-notes" />
      </Panel>
      <Panel title="Costi e margine (riservato)" testId="costs-panel">
        <div className="grid grid-cols-3 gap-3 text-sm">
          <div><div className="text-xs text-[#7B929C]">Prezzo evento</div><b>{fmtMoney(price)}</b></div>
          <div><div className="text-xs text-[#7B929C]">Costi stimati</div><b data-testid="costs-total">{fmtMoney(tot)}</b></div>
          <div><div className="text-xs text-[#7B929C]">Margine</div><b className={margin >= 0 ? "text-[#166534]" : "text-[#991B1B]"} data-testid="costs-margin">{fmtMoney(margin)} {price ? `(${Math.round((margin / price) * 100)}%)` : ""}</b></div>
        </div>
        {costs.map((x, i) => (
          <div key={i} className="flex gap-2">
            <input className={inputCls} value={x.voce} onChange={(e) => setCosts(costs.map((y, j) => (j === i ? { ...y, voce: e.target.value } : y)))} placeholder="Voce di costo" data-testid={`cost-name-${i}`} />
            <input type="number" className={`${inputCls} w-36`} value={x.importo} onChange={(e) => setCosts(costs.map((y, j) => (j === i ? { ...y, importo: e.target.value } : y)))} placeholder="€" data-testid={`cost-amount-${i}`} />
            <button className="text-[#991B1B]" onClick={() => setCosts(costs.filter((_, j) => j !== i))} data-testid={`cost-remove-${i}`}><Trash2 size={14} /></button>
          </div>
        ))}
        <div className="flex flex-wrap gap-2">
          <Button size="sm" variant="outline" className="rounded-full" onClick={() => setCosts([...costs, { voce: "", importo: "" }])} data-testid="cost-add"><Plus size={13} className="mr-1" /> Voce</Button>
          {SUGGEST.filter((s) => !costs.some((x) => x.voce === s)).slice(0, 5).map((s) => <button key={s} onClick={() => setCosts([...costs, { voce: s, importo: "" }])} className="text-xs px-3 py-1.5 rounded-full border border-dashed border-[#34B3B0]" data-testid={`cost-suggest-${s}`}>+ {s}</button>)}
        </div>
      </Panel>
      <Button className="rounded-full" onClick={save} data-testid="service-save">Salva note e costi</Button>
    </div>
  );
}
